import type { RouteRecordRaw } from 'vue-router';
import { PROMOTION_BANNER_ROUTE_NAME } from '@/consts';

export const promotionBannerRoutes: RouteRecordRaw = {
  path: '/promotion-banner',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true },
  children: [
    {
      name: PROMOTION_BANNER_ROUTE_NAME.PROMOTION_BANNER,
      path: '',
      component: () => import('./PromotionBanner.vue'),
    },
  ],
};
